import React from 'react';
import propTypes from 'prop-types';

import UserDateFormat from '../../../components/user-date-format/index';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';

import { messages } from '../messages';

const CreatedDateColumn = ({ fulfillmentId }) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { createdDateTime } = salesOrder;

  return <UserDateFormat value={createdDateTime} />;
};

CreatedDateColumn.propTypes = {
  fulfillmentId: propTypes.string.isRequired,
};

export const CreatedDate = {
  getMessageDescriptor: () => messages.createdDate,
  id: 'created-date',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <CreatedDateColumn fulfillmentId={data.id} />;
  },
};
